<template>
  <div class="bg-white relative">
    <el-tabs
      v-model="current"
      type="card"
      ref="tabs"
      @tab-remove="deleteItem"
      :before-leave="beforeLeave"
    >
      <el-tab-pane
        v-for="(audience, index) in value"
        :key="'label_' + index"
        :name="index + ''"
        closable
      >
        <span slot="label">
          <i
            class="el-icon-warning text-red-600"
            v-if="errList.includes(index)"
          ></i>
          受众{{ index + 1 }}
          <!-- <i
            class="el-icon-circle-close ml-2 text-zinc-800 hover:text-primary"
            @click="deleteItem(index)"
          ></i> -->
        </span>
        <div
          class="m-6 pr-24"
          :key="index"
        >
          <el-form
            :model="audience"
            label-width="120px"
            :rules="rules"
            ref="form"
          >
            <p class="font-semibold text-[#666] text-[16px]">定向</p>
            <AudienceTarget
              v-model="audience.groupCriterion.target"
              :enumConstants="enumConstants"
              :data="data"
              :currentAccount="currentAccount"
              :auto-fill="true"
              location-label="地区"
              location-prop="groupCriterion.target.locations"
              language-label="语言"
              language-prop="groupCriterion.target.languages"
            />
            <!-- <el-form-item
              label="地区"
              prop="groupCriterion.target.locations"
            >
              <div class="flex">
                <el-select
                  multiple
                  filterable
                  default-first-option
                  value-key="country_code"
                  v-model="audience.groupCriterion.target.locations"
                  @change="() => onChangeLocations(audience.groupCriterion.target.locations, index)"
                >
                  <el-option-group
                    v-for="group in countryList"
                    :key="group.label"
                    :label="group.label"
                  >
                    <el-option
                      v-for="item in group.options"
                      :key="item.country_code"
                      :label="item.name_zhcn"
                      :value="item"
                    >
                    </el-option>
                  </el-option-group>
                </el-select>
                <el-button
                  type="text"
                  @click="autoFillLocations(index)"
                  class="!ml-2"
                  >自动填充</el-button
                >
              </div>
            </el-form-item>
            <el-form-item label="排除地区"> </el-form-item>
            <el-form-item label="语言">
              <el-select
                multiple
                filterable
                default-first-option
                v-model="audience.groupCriterion.target.languages"
              >
                <el-option
                  v-for="languages in enumConstants.languages"
                  :label="languages.nameZhcn"
                  :value="languages.id"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <p
              class="font-semibold text-[#666] text-[16px]"
              v-if="['TARGET_CPA', 'TARGET_ROAS'].includes(data.bidStrategy)"
            >
              广告组目标
            </p>
            <el-form-item
              label=""
              v-if="['TARGET_CPA', 'TARGET_ROAS'].includes(data.bidStrategy)"
            >
              <AdsetBid
                ref="adsetBid"
                :currentAccount="currentAccount"
                :value="{ ...audience, campaignBidStrategy: data.bidStrategy }"
                @input="(v) => setAdsetBid(v, index)"
              />
            </el-form-item>
            <p class="font-semibold text-[#666] text-[16px]">投放渠道</p>
            <el-form-item label="投放渠道">
              <ChannelType v-model="audience.channelSetting" />
            </el-form-item>
            <p class="font-semibold text-[#666] text-[16px]">受众</p>
            <el-form-item label="受众群体">
              <AudienceGroup
                ref="audienceGroup"
                :value="getAudienceResourceName(audience)"
                @input="(v) => setAudienceResourceName(index, v)"
                :accountId="currentAccount.id"
                :defaultList="constData.audienceGroupList"
                :currentAccount="currentAccount"
                :interestList="interestList"
                :data="data"
                :audienceData="audience.groupCriterion"
                :enumConstants="enumConstants"
                @selectAudienceGroup="(v) => selectAudienceGroup(index, v)"
                @setAudienceGroupList="setAudienceGroupList"
              />
            </el-form-item>
            <el-form-item
              label="性别"
              prop="sex"
            >
              <AudienceSex
                :value="getAudienceGenders(audience)"
                @input="(v) => setAudienceGenders(index, v)"
                :disabled="true"
              />
            </el-form-item>
            <el-form-item label="年龄">
              <AudienceAge
                :value="getAudienceAgeRange(audience)"
                @input="(v) => setAudienceAgeRange(index, v)"
                :disabled="true"
              />
            </el-form-item>
            <el-form-item label="自定义细分受众">
              <CustomAudience
                ref="customAudience"
                :currentAccount="currentAccount"
                :defaultList="constData.customAudienceList"
                :value="getAudienceCustomAudiences(audience)"
                @input="(v) => setAudienceCustomAudiences(index, v)"
                :disabled="true"
                @setCustomAudienceList="setCustomAudienceList"
              />
            </el-form-item>
            <el-form-item label="兴趣和详细受众">
              <InterestAudience
                ref="interestAudience"
                :value="getAudienceUserInterests(audience)"
                @input="(v) => setAudienceUserInterests(index, v)"
                :list="interestList"
                :listLoading="interestListLoading"
                :interestLabelSaveAPI="interestLabelSaveAPI"
                :countryCodes="audience.groupCriterion.target.locations"
                :defaultList="constData.interestLabelQueryList"
                :accountId="currentAccount.id"
                :defaultExpandAll="false"
                :disabled="true"
                @setInterestLabelQueryList="setInterestLabelQueryList"
              ></InterestAudience>
            </el-form-item>
            <el-form-item label="您的数据">
              <YourData
                ref="yourData"
                :value="getAudienceUserLists(audience)"
                @input="(v) => setAudienceUserLists(index, v)"
                :currentAccount="currentAccount"
                :defaultList="constData.yourDataList"
                :data="data"
                :disabled="true"
                @setYourDataList="setYourDataList"
              />
            </el-form-item>
            <el-form-item label="相似受众">
              <LikeAudience
                ref="likeAudience"
                :value="getLikeAudience(audience)"
                @input="(v) => setLikeAudience(index, v)"
                :currentAccount="currentAccount"
                :enumConstants="enumConstants"
                :defaultList="constData.likeAudienceList"
                :data="data"
                :disabled="true"
                @setLikeAudienceList="setLikeAudienceList"
              />
            </el-form-item>
            <el-form-item label="优化型定位">
              <OptimizePosition
                :value="audience"
                @input="(v) => setAudiencePosition(index, v)"
              />
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane name="add">
        <div
          slot="label"
          @click.stop="addItem"
        >
          <i class="el-icon-circle-plus-outline mr-1" />添加受众
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="absolute z-50 right-6 top-0 h-10 leading-10">
      <div
        slot="label"
        @click.stop="copyItem"
        class="hover:text-primary text-sm leading-10"
      >
        <i class="el-icon-copy-document mr-1" />复制受众
      </div>
    </div>
  </div>
</template>
<script>
import { getAudienceDefault, sexList } from '../../index.js';
import InterestAudience from './interestAudiences';
import CreateSegmentAudience from '@/views/google/create/components/audience/createSegmentAudience/index.vue';
import OptimizePosition from '@/views/google/create/components/audience/OptimizePosition/index.vue';
import AudienceAge from '@/views/google/create/components/audience/AudienceAge/index.vue';
import AudienceGroup from '@/views/google/create/components/audience/AudienceGroup/index.vue';
import AudienceSex from '@/views/google/create/components/audience/AudienceSex/index.vue';
import CustomAudience from '@/views/google/create/components/audience/CustomAudience/index';
import AudienceTarget from '@/views/google/create/components/audience/AudienceTarget/index.vue';
import YourData from '@/views/google/create/components/audience/YourData/index.vue';
import LikeAudience from '@/views/google/create/components/audience/LikeAudience/index.vue';
import ChannelType from '@/views/google/create/components/audience/ChannelType/index.vue';
import AdsetBid from '@/views/google/create/components/audience/AdsetBid/index.vue';

import _ from 'lodash';
import { rules } from './index.js';
import { selectTree } from '@adCommonComponent';
import { saveCommonInterests, listCustomerAudience, commonUseLocations, criteriaTree } from '@/api/google/create';
export default {
  components: {
    InterestAudience,
    CreateSegmentAudience,
    selectTree,
    OptimizePosition,
    AudienceAge,
    AudienceGroup,
    AudienceSex,
    CustomAudience,
    AudienceTarget,
    ChannelType,
    YourData,
    AdsetBid,
    LikeAudience,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    currentStep: {
      type: Number,
      default: 0,
    },
    data: {
      type: Object,
      default: () => {},
    },
    enumConstants: {
      type: Object,
      default: () => {},
    },
    currentAccount: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // formData: [],
      rules,
      interestList: [],
      interestListLoading: false,
      sexList, //性别遍历数据
      current: '0', // 当前受众下标
      interestLabelSaveAPI: saveCommonInterests,
      errList: [], // 验证不通过列表
      options: [],
      constData: {},
      commonLocation: [],
    };
  },
  computed: {
    countryList() {
      return [
        {
          label: '常用',
          options: this.commonLocation,
        },
        {
          label: '地区',
          options: this.enumConstants.countries,
        },
      ];
    },
    // 安全获取受众数据的计算属性
    safeAudienceData() {
      return this.value.map((audience) => {
        if (!audience.groupCriterion.audience) {
          return {
            ...audience,
            groupCriterion: {
              ...audience.groupCriterion,
              audience: {
                resourceName: null,
                ageRange: {
                  minAge: 18,
                  maxAge: null,
                  undetermined: true,
                },
                genders: ['UNDETERMINED', 'MALE', 'FEMALE'],
                languages: [],
                userInterests: [],
                customAudiences: [],
                userLists: [],
              },
            },
          };
        }
        return audience;
      });
    },
  },
  methods: {
    // 确保受众对象初始化
    ensureAudienceInitialized(index) {
      if (!this.value[index].groupCriterion.audience) {
        this.$set(this.value[index].groupCriterion, 'audience', {
          resourceName: null,
          ageRange: {
            minAge: 18,
            maxAge: null,
            undetermined: true,
          },
          genders: ['UNDETERMINED', 'MALE', 'FEMALE'],
          languages: [],
          userInterests: [],
          customAudiences: [],
          userLists: [],
        });
      }
    },

    // 安全获取受众数据的方法
    getAudienceResourceName(audience) {
      return audience.groupCriterion.audience ? audience.groupCriterion.audience.resourceName : null;
    },
    setAudienceResourceName(index, value) {
      this.ensureAudienceInitialized(index);
      this.$set(this.value[index].groupCriterion.audience, 'resourceName', value);
    },

    getAudienceGenders(audience) {
      return audience.groupCriterion.audience ? audience.groupCriterion.audience.genders || [] : [];
    },
    setAudienceGenders(index, value) {
      this.ensureAudienceInitialized(index);
      this.$set(this.value[index].groupCriterion.audience, 'genders', value);
    },

    getAudienceAgeRange(audience) {
      return audience.groupCriterion.audience
        ? audience.groupCriterion.audience.ageRange || { minAge: 18, maxAge: null, undetermined: true }
        : { minAge: 18, maxAge: null, undetermined: true };
    },
    setAudienceAgeRange(index, value) {
      this.ensureAudienceInitialized(index);
      this.$set(this.value[index].groupCriterion.audience, 'ageRange', value);
    },

    getAudienceCustomAudiences(audience) {
      return audience.groupCriterion.audience ? audience.groupCriterion.audience.customAudiences || [] : [];
    },
    setAudienceCustomAudiences(index, value) {
      this.ensureAudienceInitialized(index);
      this.$set(this.value[index].groupCriterion.audience, 'customAudiences', value);
    },

    getAudienceUserInterests(audience) {
      return audience.groupCriterion.audience ? audience.groupCriterion.audience.userInterests || [] : [];
    },
    setAudienceUserInterests(index, value) {
      this.ensureAudienceInitialized(index);
      this.$set(this.value[index].groupCriterion.audience, 'userInterests', value);
      this.getInterest(index, value);
    },

    getAudienceUserLists(audience) {
      return audience.groupCriterion.audience ? audience.groupCriterion.audience.userLists || [] : [];
    },
    setAudienceUserLists(index, value) {
      this.ensureAudienceInitialized(index);
      this.$set(this.value[index].groupCriterion.audience, 'userLists', value);
    },
    getLikeAudience(audience) {
      return audience.groupCriterion.audience ? audience.groupCriterion.audience.lookalikeUserLists || [] : [];
    },
    setLikeAudience(index, value) {
      this.ensureAudienceInitialized(index);
      this.$set(this.value[index].groupCriterion.audience, 'lookalikeUserLists', value);
    },

    addItem() {
      this.value.push(getAudienceDefault());
      this.$emit('input', this.value);
      // 添加受众后自动触发填充
      this.$nextTick(() => {
        this.triggerAutoFill(this.value.length - 1);
      });
    },
    // 触发指定索引受众的自动填充
    triggerAutoFill(index) {
      if (!this.data?.promoteInfo?.site?.countryCode) return;
      const val = this.data.promoteInfo.site.countryCode;
      const countries = this.enumConstants.countries?.filter((v) => v.country_code == val) || [];
      if (countries.length > 0 && this.value[index]) {
        this.$set(this.value[index].groupCriterion.target, 'locations', countries);
        // 设置默认语言
        const languagesDefault = [...new Set(countries.map((v) => v.defaultLanguageIds).flat())];
        this.$set(this.value[index].groupCriterion.target, 'languages', languagesDefault);
      }
    },
    copyItem() {
      let current = this.value[this.current];
      this.value.push(JSON.parse(JSON.stringify(current)));
      this.$emit('input', this.value);
    },
    deleteItem(index) {
      if (this.value.length == 1) {
        this.$message({
          type: 'warning',
          message: '至少保留一个受众',
        });
        return;
      }
      this.value.splice(index, 1);
      if (this.current >= this.value.length) {
        this.current = `${this.value.length - 1}`;
      }
      this.$emit('input', this.value);
    },
    beforeLeave(active, oldActive) {
      console.log(active, oldActive);
      if (active == 'add') {
        this.addItem();
        return false;
      }
    },
    /**
     * 选择受众群体
     */
    selectAudienceGroup(index, v) {
      // 确保 audience 对象存在
      this.ensureAudienceInitialized(index);

      if (v) {
        this.value[index].groupCriterion.audience = { ...v };
        this.value[index].groupCriterion.audience.userInterests = v.userInterests || [];
        this.value[index].groupCriterion.audience.customAudiences = v.customAudiences || [];
        this.value[index].groupCriterion.audience.genders = v.genders || [];
        if (this.$refs.interestAudience && this.$refs.interestAudience[index]) {
          this.$refs.interestAudience[index].interestLabelQuery = [];
        }
      } else {
        this.value[index].groupCriterion.audience = {
          resourceName: null,
          ageRange: {
            minAge: 18,
            maxAge: null,
            undetermined: true,
          }, //年龄
          genders: ['UNDETERMINED', 'MALE', 'FEMALE'], // 性别
          languages: [], // 语言
          userInterests: [], // 兴趣词
          customAudiences: [], // 自定义受众
          userLists: [], // 您的数据
        };
      }
    },
    /* 绑定受众定位的值*/
    setAudiencePosition(index, v) {
      this.$set(this.value, index, { ...this.value[index], ...v });
    },
    // // 自动填充地区
    // autoFillLocations(index) {
    //   let val = this.data.promoteInfo.site.countryCode;
    //   let countries = this.enumConstants.countries.filter((v) => v.country_code == val);
    //   console.log(countries);
    //   this.$set(this.value[index].groupCriterion.target, 'locations', countries);
    //   this.onChangeLocations(countries, index);
    // },
    // // 修改地区
    // onChangeLocations(val, index) {
    //   console.log(val);
    //   let languagesDefault = [...new Set(val.map((v) => v.defaultLanguageIds).flat())];
    //   this.$set(this.value[index].groupCriterion.target, 'languages', languagesDefault);
    // },
    getInterest(index, v) {
      // 确保受众对象存在
      this.ensureAudienceInitialized(index);
      console.log(index, v);
      this.$forceUpdate();
    },
    setAdsetBid(v, index) {
      this.$set(this.value, index, { ...this.value[index], ...v });
    },
    // 对外验证
    validate() {
      let list = [];
      this.errList = [];
      this.$refs.form.map((form, index) => {
        list.push(form.validate().catch(() => index));
      });

      // 校验AdsetBid组件
      if (this.$refs.adsetBid && ['TARGET_CPA', 'TARGET_ROAS'].includes(this.data.bidStrategy)) {
        this.$refs.adsetBid.forEach((adsetBid, index) => {
          if (adsetBid && !adsetBid.validate()) {
            this.errList.push(index);
          }
        });
      }

      return new Promise((resolve, reject) => {
        Promise.allSettled(list).then((res) => {
          res.map((item) => {
            if (typeof item.value == 'number') {
              this.errList.push(item.value);
            }
          });
          if (this.errList.length > 0) {
            reject();
          } else {
            resolve();
          }
        });
      });
    },
    clearValidate() {
      if (!this.$refs.form) return;
      let list = [];
      this.errList = [];
      this.$refs.form.map((form, index) => {
        list.push(form.clearValidate());
      });
      return Promise.all(list);
    },
    /*获取下拉框的值*/
    async getConstDataList() {
      await this.$refs.audienceGroup?.[0].getAudienceGroupList();
      await this.$refs.interestAudience?.[0].getInterestLabelQueryList();
      await this.$refs.customAudience?.[0].getCustomAudienceList();
      await this.$refs.yourData?.[0].getYourDataList();
      await this.$refs.likeAudience?.[0].getLookalikeList();
      this.$nextTick(() => {
        this.constData = {
          audienceGroupList: this.$refs.audienceGroup?.[0].audienceGroupList,
          customAudienceList: this.$refs.customAudience?.[0].customAudienceList,
          interestLabelQueryList: this.$refs.interestAudience?.[0].interestLabelQueryList,
          yourDataList: this.$refs.yourData?.[0].yourDataList,
          likeAudienceList: this.$refs.likeAudience?.[0].lookalikeDataList,
        };
        console.log(this.constData, ' this.constData  this.constData ');
      });
    },

    // 更新下拉框的值 - 公共方法
    updateConstData(key, value) {
      this.$set(this.constData, key, value);
    },
    setAudienceGroupList(v) {
      this.updateConstData('audienceGroupList', v);
    },
    setCustomAudienceList(v) {
      this.updateConstData('customAudienceList', v);
    },
    setInterestLabelQueryList(v) {
      this.updateConstData('interestLabelQueryList', v);
    },
    setYourDataList(v) {
      this.updateConstData('yourDataList', v);
    },
    setLikeAudienceList(v) {
      this.updateConstData('likeAudienceList', v);
    },
    getCommonUseLocations() {
      commonUseLocations({ accountId: this.currentAccount.id }).then((res) => {
        this.commonLocation = res.data;
      });
    },
    // 获取受众词
    getInterestList() {
      this.interestListLoading = true;
      criteriaTree()
        .then((res) => {
          this.interestList = res.data;
        })
        .finally(() => {
          this.interestListLoading = false;
        });
    },
  },
  created() {},
  watch: {
    value: {
      handler(newVal) {
        // 确保所有受众对象都正确初始化
        if (newVal && Array.isArray(newVal)) {
          newVal.forEach((audience, index) => {
            if (!audience.groupCriterion.audience) {
              this.ensureAudienceInitialized(index);
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
    currentStep() {
      if (this.currentStep == 2) {
        if (Object.keys(this.constData).length > 0) {
          return;
        }
        this.getCommonUseLocations();
        this.getConstDataList();
        this.getInterestList();
        // 进入受众步骤时，为所有没有地区的受众自动填充
        this.$nextTick(() => {
          this.value.forEach((audience, index) => {
            if (!audience.groupCriterion.target.locations || audience.groupCriterion.target.locations.length === 0) {
              this.triggerAutoFill(index);
            }
          });
        });
      }
    },
  },
};
</script>
